<div
  class="platform-container"
  [ngClass]="'theme-' + platformConfigService.currentPlatform$()"
  [class.sidebar-pinned]="sidebarPinned()"
>
  <app-platform-header
    [config]="platformConfigService.currentConfig() ?? null"
    [availablePlatforms]="userPlatforms"
    [isSidebarPinned]="sidebarPinned()"
    (platformChange)="onPlatformChange($event)"
    (logout)="onLogout()"
    (menuToggle)="toggleSidebar()"
  ></app-platform-header>
  @if (sidebarVisible() && !sidebarPinned()) {
    <div class="sidebar-backdrop" (click)="closeSidebar()"></div>
  }
  <app-platform-sidebar
    [config]="platformConfigService.currentConfig() ?? null"
    [menuItems]="currentMenuItems()"
    [isVisible]="sidebarVisible()"
    [isPinned]="sidebarPinned()"
    (sidebarClosed)="closeSidebar()"
    (pin)="togglePin()"
    (logout)="onLogout()"
  ></app-platform-sidebar>
  <main
    #contentScroll
    class="content-area"
    [class.no-padding]="isCheckInPage()"
  >
    <router-outlet></router-outlet>
  </main>
  <app-logout-modal
    [visible]="logoutModalVisible()"
    (confirm)="confirmLogout()"
    (cancel)="cancelLogout()"
  ></app-logout-modal>
</div>
